var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "input input--select",
      class: { "input--secondary": _vm.secondary }
    },
    [
      _vm.label
        ? _c(
            "label",
            { attrs: { for: "select" + _vm._uid, id: "deliverEveryLabel" } },
            [_vm._v(_vm._s(_vm.label))]
          )
        : _vm._e(),
      !_vm.showNativeSelect
        ? _c("v-select", {
            ref: "vSelect",
            attrs: {
              options: _vm.optionSet,
              disabled: _vm.$attrs.disabled,
              clearable: false,
              value: _vm.selectedValue,
              placeholder: _vm.defaultOption,
              searchable: false,
              "select-on-tab": true,
              id: "select" + _vm._uid,
              "aria-labelledby": `deliverEveryLabel`
            },
            on: {
              keydown: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "space", 32, $event.key, [
                    " ",
                    "Spacebar"
                  ])
                )
                  return null
                $event.preventDefault()
                $event.stopPropagation()
                return _vm.toggleDropdown.apply(null, arguments)
              },
              input: _vm.update
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "open-indicator",
                  fn: function({ attributes }) {
                    return [
                      _c(
                        "span",
                        _vm._b(
                          {
                            attrs: { "menu-open-on-focus": true },
                            on: {
                              keydown: function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "space",
                                    32,
                                    $event.key,
                                    [" ", "Spacebar"]
                                  )
                                )
                                  return null
                                $event.preventDefault()
                                $event.stopPropagation()
                                return (event =>
                                  _vm.$refs.vSelect.toggleDropdown).apply(
                                  null,
                                  arguments
                                )
                              }
                            }
                          },
                          "span",
                          attributes,
                          false
                        ),
                        [
                          _c("icon", {
                            attrs: { name: "chevron-down", size: "22px" }
                          })
                        ],
                        1
                      )
                    ]
                  }
                }
              ],
              null,
              false,
              2145669241
            )
          })
        : [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.currentValue,
                    expression: "currentValue"
                  }
                ],
                attrs: {
                  disabled: _vm.$attrs.disabled,
                  id: "select" + _vm._uid
                },
                on: {
                  change: function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.currentValue = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  }
                }
              },
              [
                _c(
                  "option",
                  { attrs: { value: "", disabled: "", selected: "" } },
                  [_vm._v("Select an Option")]
                ),
                _vm._l(_vm.options, function(option) {
                  return _c(
                    "option",
                    { key: option.value, domProps: { value: option.value } },
                    [_vm._v(_vm._s(option.label))]
                  )
                })
              ],
              2
            ),
            _c(
              "div",
              { staticClass: "icon--default-select" },
              [_c("icon", { attrs: { name: "chevron-down", size: "22px" } })],
              1
            )
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }